import type { PortableTextComponentProps } from '~/components/atoms/BlockContent/BlockContent'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import { Col, Grid, Row } from '~/components/atoms/Grid'
import type { ImageProps } from '~/components/atoms/Image/Image'
import Image from '~/components/atoms/Image/Image'
import { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'
import { AnimatedGifsVariants } from '~/enums/animatedGifsVariants'

import styles from './AnimatedGifs.module.css'

export interface AnimatedGifsProps {
  variant: AnimatedGifsVariants
  image1: ImageProps
  image2?: ImageProps
  image3?: ImageProps
  body?: PortableTextComponentProps['blocks']
  verticalPadding?: boolean
  testID?: string
  moduleId?: string
}

export default function AnimatedGifs({
  variant,
  image1,
  image2,
  image3,
  body,
  verticalPadding,
  testID,
  moduleId,
}: AnimatedGifsProps) {
  return (
    <Fixture
      theme={ComponentTheme.black}
      verticalPadding={variant === AnimatedGifsVariants.ImageWithText}
      id={moduleId}
    >
      <Container gutters={gutterTypes.always}>
        <div className={styles.base} data-testid={testID}>
          {variant === AnimatedGifsVariants.SingleImage && (
            <Image asset={image1.asset} alt={'Image 1'} />
          )}

          {variant === AnimatedGifsVariants.TripleImage && (
            <Grid cssClass={styles.dividers} largeGutters>
              <Row>
                <Col variant="col-1/3--md">
                  <Image asset={image1.asset} alt={'Image 1'} />
                </Col>
                <Col variant="col-1/3--md">
                  {image2 && <Image asset={image2.asset} alt={'Image 2'} />}
                </Col>
                <Col variant="col-1/3--md">
                  {image3 && <Image asset={image3.asset} alt={'Image 3'} />}
                </Col>
              </Row>
            </Grid>
          )}

          {variant === AnimatedGifsVariants.DoubleImage && (
            <Grid cssClass={styles.dividers} largeGutters>
              <Row>
                <Col variant="col-1/2--md">
                  <Image asset={image1.asset} alt={'Image 1'} />
                </Col>
                <Col variant="col-1/2--md">
                  {image2 && <Image asset={image2.asset} alt={'Image 2'} />}
                </Col>
              </Row>
            </Grid>
          )}

          {variant === AnimatedGifsVariants.ImageWithText && (
            <Grid>
              <Row>
                <Col variant="col-1/2--md">
                  <Image asset={image1.asset} alt={'Image 1'} />
                </Col>
                <Col variant="col-1/2--md">
                  {body && (
                    <div className={`${styles.body} prose`}>
                      <BlockContent
                        value={body}
                        size={TextSizes.bodyLrg}
                      ></BlockContent>
                    </div>
                  )}
                </Col>
              </Row>
            </Grid>
          )}
        </div>
      </Container>
    </Fixture>
  )
}
